/* global analytics */

import * as firebase from 'firebase';

export default class auth {

    constructor(callback) {
        firebase.auth().onAuthStateChanged(function(user) {
            if(callback) {
                if(user) {
                    // Provide user object, but overwrite providerData UID
                    // as that is not the user's key but email address.
                    let userData = JSON.parse(JSON.stringify(user.providerData[0]));
                    userData.uid = user.uid;

                    analytics.identify(user.uid, {
                        name: userData.displayName,
                        email: userData.email,
                        emailVerified: userData.emailVerified,
                    });

                    callback(userData);
                } else {
                    callback(false);
                }
            }
        });
    }

    login(email, password, onSuccess, onFailure) {
        firebase.auth().signInWithEmailAndPassword(email, password)
        .then(function() {
            if(onSuccess) onSuccess();
        })
        .catch(function(error) {
            if(onFailure) onFailure(error.message);
        });
    }

    register(email, password, firstName, onSuccess, onFailure) {
        firebase.auth().createUserWithEmailAndPassword(email, password)
        .then((user) => {
            user.updateProfile({
                displayName: firstName,
            }).then(() => {
                if(onSuccess) onSuccess();
            }).catch((error) => {
                if(onFailure) onFailure(error.message);
            });
        })
        .catch((error) => {
            if(onFailure) onFailure(error.message);
        });
    }

    logout(onSuccess, onFailure) {
        firebase.auth().signOut()
        .then(function() {
            if(onSuccess) onSuccess();
        })
        .catch(function(error) {
            if(onFailure) onFailure(error.message);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/auth.js